export default {
  navigationBarTitleText: '填写分享信息'
};
